import { cn } from "tailwind-variants";
import { useGetSiteSettings } from "#/_packages/umbrella/hooks/useGetSiteSettings.ts";
import { BlockGrid } from "#/_packages/umbrella/integrations/umbraco/property-components/block-grid.tsx";

const getSiteFooterDivider = (value: string | null | undefined) => {
	switch (value) {
		case "none":
			return "";
		case "content":
			return "site-footer-divider-content";
		case "full":
			return "site-footer-divider-full";
		default:
			return "";
	}
};

export default function Footer() {
	const siteSettings = useGetSiteSettings();

	const siteFooterDivider = getSiteFooterDivider(
		siteSettings?.pageFooterDivider,
	);

	const hasFooterContent =
		siteSettings?.footerContentArea != null &&
		siteSettings?.footerContentArea.items.length > 0;

	return hasFooterContent ? (
		<footer className={cn("site-footer", siteFooterDivider)}>
			<BlockGrid
				noVerticalSpacing={siteSettings.footerNoVerticalSpacing ?? false}
				className="gap-0"
				key={"footer"}
				contentArea={siteSettings?.footerContentArea ?? undefined}
			/>
		</footer>
	) : null;
}
